module.exports = __webpack_public_path__ + "static/img/img01.c0befc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advance/img01.png
// module id = 0iup
// module chunks = 1